module.exports = __webpack_public_path__ + "static/03_home_screen_v1.620b644f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/03_home_screen_v1.jpg
// module id = 512
// module chunks = 111663361672460